import { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import LeadOutlook from "../components/LeadOutlook";
import { Sun, CheckCircle2, Loader2 } from "lucide-react";

const eur = (v) => Number(v || 0).toLocaleString("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });

export default function PublicOutlook() {
  const { token } = useParams();
  const [params, setParams] = useSearchParams();
  const [refreshKey, setRefreshKey] = useState(0);
  const [banner, setBanner] = useState(null); // {type, text}
  const attempts = useRef(0);

  useEffect(() => {
    document.title = "La tua proposta · Torrisolare";
  }, []);

  useEffect(() => {
    if (params.get("cancel") === "1") {
      setBanner({ type: "info", text: "Pagamento annullato. Nessun addebito effettuato." });
      params.delete("cancel"); setParams(params, { replace: true });
      return;
    }
    const sid = params.get("session_id");
    if (params.get("paid") === "1" && sid) {
      setBanner({ type: "checking", text: "Conferma del pagamento in corso…" });
      let stop = false;
      const poll = async () => {
        if (stop) return;
        attempts.current += 1;
        try {
          const { data } = await api.get(`/public/payments/status/${sid}`);
          if (data.payment_status === "paid") {
            setBanner({ type: "paid", text: `Caparra pagata (${eur(data.amount)}). Ordine confermato${data.commessa ? ` · commessa ${data.commessa}` : ""}. La caparra sarà interamente scomputata dal saldo finale.` });
            setRefreshKey((k) => k + 1);
            params.delete("paid"); params.delete("session_id"); setParams(params, { replace: true });
            return;
          }
        } catch { /* keep polling */ }
        if (attempts.current > 15) { setBanner({ type: "info", text: "Verifica pagamento non riuscita. Ricarica la pagina o riprova." }); return; }
        setTimeout(poll, 2000);
      };
      poll();
      return () => { stop = true; };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <div className="sticky top-0 z-10 border-b border-border bg-background/90 backdrop-blur px-4 sm:px-6 py-3 flex items-center gap-2">
        <img src="/torri-icon.png" alt="TORRI.SOLAR" className="h-9 w-9 rounded-full object-contain" />
        <div className="leading-tight">
          <div className="font-heading font-extrabold text-sm tracking-wide">TORRI<span style={{ color: "#FDD003" }}>.SOLAR</span></div>
          <div className="text-[10px] text-muted-foreground uppercase tracking-[0.15em]">Div. Chiavi in mano</div>
        </div>
      </div>

      {banner && (
        <div className={`px-4 sm:px-6 py-3 text-sm font-medium flex items-center gap-2 ${banner.type === "paid" ? "bg-green-500/15 text-green-500" : banner.type === "checking" ? "bg-primary/10 text-primary" : "bg-secondary text-muted-foreground"}`} data-testid="public-banner">
          {banner.type === "checking" ? <Loader2 className="h-4 w-4 animate-spin" /> : banner.type === "paid" ? <CheckCircle2 className="h-4 w-4" /> : null}
          {banner.text}
        </div>
      )}

      <div className="mx-auto max-w-4xl px-4 sm:px-6 py-6 sm:py-8">
        <LeadOutlook publicToken={token} refreshKey={refreshKey} />
      </div>
    </div>
  );
}
